'use client';

import React, { createContext, useContext } from 'react';
import type { ReactNode } from 'react';
import type { InitialUserData } from '@/src/lib/api/endpoints/user';

const InitialUserContext = createContext<InitialUserData | null | undefined>(undefined);

type InitialUserProviderProps = {
  children: ReactNode;
  initialUser?: InitialUserData | null;
};

export function InitialUserProvider(props: InitialUserProviderProps) {
  const { children } = props;
  const initialUser = Object.prototype.hasOwnProperty.call(props, 'initialUser')
    ? props.initialUser
    : null;

  return <InitialUserContext.Provider value={initialUser}>{children}</InitialUserContext.Provider>;
}

export function useInitialUser() {
  return useContext(InitialUserContext);
}
